import { Integration_Auth_Names_Enum, Integration_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';

export type CloudflareConnectorConfig = typeof CloudflareConnector._.Config;

export const CloudflareConnector = IntegrationConnector.make({
  provider: Integration_Names_Enum.Cloudflare,
  logoPath: 'images/cloudflare-logo.svg',
  categories: [IntegrationConnectorCategory.Cloud, IntegrationConnectorCategory.Security],
  auths: IntegrationAuth.group([
    IntegrationAuth.manual({
      name: Integration_Auth_Names_Enum.ApiToken,
      configSchema: z.object({}),
      encryptedConfigSchema: z.object({
        apiToken: z.string().min(40),
      }),
    }),
  ]),
});
